// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs
class UltracleanCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.initializeCarousel()
  }

  initializeCarousel () {
    if (!this.els?.slides?.exists || !this.slide.exists) return

    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: this.numberOfSlidesMobile,
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 901px)': {
          slides: {
            perView: this.numberOfSlidesTablet,
            spacing: 20,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: this.numberOfSlidesDesktop,
            spacing: 20,
          },
        },
      },
    })
  }

  get numberOfSlidesMobile () {
    return this.slides?.dataset.slidesMobile
  }

  get numberOfSlidesTablet () {
    return this.slides?.dataset.slidesTablet
  }

  get numberOfSlidesDesktop () {
    return this.slides?.dataset.slidesDesktop
  }

  get slides () {
    return this.els?.slides?.element
  }

  get slide () {
    return this.els?.slide
  }
}

if (!customElements.get('ultraclean-carousel')) {
  customElements.define('ultraclean-carousel', UltracleanCarousel)
}
